import {
    RegionQuery as SourceRegionQuery
} from 'SourceQuery/Region.query';
import { Field } from 'Util/Query';

/** @namespace Elganso/Query/Region/Query */
export class RegionQuery extends SourceRegionQuery {
    getCountriesQuery() {
        return new Field('countries')
            .addFieldList(this._getCountryFields());
    }

    _getCountryFields() {
        return [
            'id',
            'is_state_required',
            'zonas_chile',
            this._getAvailableRegionsField(),
            new Field('full_name_locale').setAlias('label')
        ];
    }
}

export default new RegionQuery();
